module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-org"
  }, [_c('ep-title', {
    attrs: {
      "title": "单位列表"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.changeCompany
    }
  }, [_vm._v(" 切换单位 ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.toAddOrg
    }
  }, [_vm._v(" 添加 ")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.datalist,
      "align": "left",
      "highlight-current-row": ""
    },
    on: {
      "row-click": _vm.searchDetail
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "80",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "单位类型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 0) ? _c('span', [_vm._v("企事业单位")]) : _vm._e(), _vm._v(" "), (scope.row.type == 1) ? _c('span', [_vm._v("政府单位")]) : _vm._e(), _vm._v(" "), (scope.row.type == 2) ? _c('span', [_vm._v("工业园区")]) : _vm._e(), _vm._v(" "), (scope.row.type == 3) ? _c('span', [_vm._v("饮用水源地")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "单位名称",
      "prop": "name",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "id",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.id) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所在区县",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.getCountys(scope.row.regions)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所在市",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.getCitys(scope.row.regions)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "成员数量",
      "align": "center",
      "prop": "count"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "我的角色",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.role == 1) ? _c('span', [_vm._v("管理员")]) : _vm._e(), _vm._v(" "), (scope.row.role == 2) ? _c('span', [_vm._v("普通用户")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "创建时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatTime(scope.row.createtime)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_c('el-pagination', {
    attrs: {
      "page-size": _vm.pageSize,
      "page-sizes": [12, 25, 50],
      "current-page": _vm.currentPage,
      "layout": "total,sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "单位类型",
      "size": "tiny"
    },
    model: {
      value: (_vm.selectShow),
      callback: function($$v) {
        _vm.selectShow = $$v
      },
      expression: "selectShow"
    }
  }, [_c('p', {
    staticClass: "m-p"
  }, [_vm._v("报单位类型一旦选择无法更改，请仔细阅读说明后选择")]), _vm._v(" "), _c('div', {
    staticClass: "m-radio"
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.radioChange
    },
    model: {
      value: (_vm.radio2),
      callback: function($$v) {
        _vm.radio2 = $$v
      },
      expression: "radio2"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0",
      "disabled": _vm.isTypeDisabled('0')
    }
  }, [_vm._v("企事业单位（企业、工厂、事业单位）")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1",
      "disabled": _vm.isTypeDisabled('1')
    }
  }, [_vm._v("政府")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2",
      "disabled": _vm.isTypeDisabled('2')
    }
  }, [_vm._v("工业园区")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3",
      "disabled": _vm.isTypeDisabled('3')
    }
  }, [_vm._v("饮用水源地保护区")])], 1), _vm._v(" "), (_vm.limitHint) ? _c('p', {
    staticClass: "limit-hint"
  }, [_vm._v(_vm._s(_vm.limitHint))]) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#20a0ff"
    }
  }, [_vm._v(_vm._s(_vm.tip))])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.selectShow = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.selectShowdiv
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "切换申报单位",
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "content-box",
    staticStyle: {
      "height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('ul', {
    staticClass: "content-con"
  }, _vm._l((_vm.detail), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.liclick(item, index)
        }
      }
    }, [_c('a', {
      class: {
        active: _vm.selectIndex === index
      }
    }, [_vm._v(_vm._s(item.value))])])
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changeSure
    }
  }, [_vm._v("确定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2e545d6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/unitmanage/myunit.vue
// module id = 1280
// module chunks = 2